import React from 'react';

import * as ST from './styled';

const VideoServices: React.FC = (): JSX.Element => {
    const imgPathWebServices = '/static/images/movix-new/video-services.png';

    return (
        <ST.VideoServicesWrapper>
            <ST.Container>
                <ST.Title>
                    <h2>
                        {'Всё, что вы смотрите — \n теперь в одной приставке'}
                    </h2>
                </ST.Title>
                <ST.SubText>
                    {'Не нужно переключаться между приложениями,\n всё собрано в одном месте.'}
                </ST.SubText>
                <ST.ImgServices src={imgPathWebServices} alt={'Кинопоиск, Амедиатека, Ivi, Start, Viju, Premier'}/>
            </ST.Container>
        </ST.VideoServicesWrapper>
    );
};

export default VideoServices;
